import $ from 'jquery'

const appId = 'u4CoaEwHtInP8VCYCUDnAEZacCyzbFv0'
const appSecret = '6xU47BazKuvjLutlVhZbRk81p4X5XbS4'
const locationId = '1'
export default {
	$ajax (options, secretRequired, sessionToken) {
		let localhost = 'https://ecomm.api.unoapp.io/api'
		options.url = localhost + options.url

		if (secretRequired) {
			options.beforeSend = (xhr) => {
				xhr.setRequestHeader('app-id', appId)
				xhr.setRequestHeader('app-secret', appSecret)
				if (sessionToken) {
					xhr.setRequestHeader('auth-token', sessionToken)
				}
			}
		}
		$.ajax(options)
	},
	getLocation () {
		return locationId
	}
}



// WEBPACK FOOTER //
// ./src/global.js